<div class="header-mobile">
  <div class="header-mobile__title title-m">{{ title() | translate }}</div>
  <div class="header-mobile__back">
    @if (showBack()) {
      <button
        im-icon-button
        [attr.aria-label]="'general.back_a' | translate"
        (click)="onBack($event)"
      >
        <i class="icon icon--arrow-left" aria-hidden="true"></i>
      </button>
    }
  </div>
  <div class="header-mobile__close">
    @if (showClose()) {
      <button
        im-icon-button
        [attr.aria-label]="'general.close_a' | translate"
        (click)="onClose($event)"
      >
        <i class="icon icon--close" aria-hidden="true"></i>
      </button>
    }
  </div>
</div>
